import {
  AlarmControlButton,
  GenericControlButton
} from '@apps-common/apps/portal/pages/units/pages/manage/components/controls/control-buttons'
import { CONTROL_TYPE_ACCESS_CONTROL, CONTROL_TYPE_ALARM } from '@apps-common/config/controls'
import { IUnitControlWithStateModel } from '@apps-common/types/portal/unit-control'

import { StateControlButton } from './control-buttons/StateControlButton'

interface IProps {
  // navigation?: IAppNavigation
  unitStatus: string
  isActivated: boolean
  containerClasses?: string
  // colors: ResolvedControlTheme
  control: IUnitControlWithStateModel
  onStateUpdatedCallback?: (data: IUnitControlWithStateModel) => void
  idPrefix: string
  showDefaultControlOptions?: boolean
}

export const Control = ({
  // navigation,
  unitStatus,
  isActivated,
  containerClasses,
  // colors,
  control,
  onStateUpdatedCallback,
  idPrefix,
  showDefaultControlOptions
}: IProps) => {
  if (control.controlTypeId === CONTROL_TYPE_ALARM || control.controlTypeId === CONTROL_TYPE_ACCESS_CONTROL) {
    return (
      <AlarmControlButton
        // navigation={navigation}
        unitStatus={unitStatus}
        isActivated={isActivated}
        containerClasses={containerClasses}
        // colors={colors}
        control={control}
        onStateUpdatedCallback={onStateUpdatedCallback}
        idPrefix={idPrefix}
        showDefaultControlOptions={showDefaultControlOptions}
      />
    )
  }

  if (control.requiresControlState) {
    return (
      <StateControlButton
        // navigation={navigation}
        unitStatus={unitStatus}
        isActivated={isActivated}
        containerClasses={containerClasses}
        // colors={colors}
        control={control}
        onStateUpdatedCallback={onStateUpdatedCallback}
        idPrefix={idPrefix}
        showDefaultControlOptions={showDefaultControlOptions}
      />
    )
  }

  return (
    <GenericControlButton
      // navigation={navigation}
      unitStatus={unitStatus}
      isActivated={isActivated}
      containerClasses={containerClasses}
      // colors={colors}
      control={control}
      onStateUpdatedCallback={onStateUpdatedCallback}
      idPrefix={idPrefix}
      showDefaultControlOptions={showDefaultControlOptions}
    />
  )
}
